import React from 'react';
import { Alert, Glyphicon } from 'react-bootstrap';
import { CSSTransitionGroup } from 'react-transition-group';
import { stringReplace } from '../../utils/core';
import translations from '../../translations';

/**
 * Present a confirmation of the published flow with details of the Flow and Tenant IDs
 *
 * @param {Object} publishedFlow The Flow that was deployed
 * @param {String} tenantId The current Tenant Id
 * @param {Object} selectedRuntime The runtime we published the Flow to.
 */
const ActivateSuccessRuntime = ({ publishedFlow, tenantId, selectedRuntime }) => (

    <React.Fragment>
        <h3>{`Your flow has been published successfully to ${selectedRuntime.developerName}!`}</h3>
        <CSSTransitionGroup
            transitionName="thumbs-up"
            transitionAppear
            transitionAppearTimeout={500}
            transitionLeave={false}
            transitionEnterTimeout={0}
        >
            <Glyphicon glyph="thumbs-up" />
        </CSSTransitionGroup>
        <p><strong>Player configuration values</strong></p>
        <p>
            <table className="table published-local">
                <tr>
                    <td className="published-tenant-id config-label">Tenant ID</td>
                    <td className="published-tenant-id config-value"><pre>{tenantId}</pre></td>
                </tr>
                <tr>
                    <td className="published-flow-id config-label">Flow ID</td>
                    <td className="published-flow-id config-value"><pre>{publishedFlow.id.id}</pre></td>
                </tr>
                <tr>
                    <td className="published-flow-version-id config-label">Version ID</td>
                    <td className="published-flow-version-id config-value"><pre>{publishedFlow.id.versionId}</pre></td>
                </tr>
            </table>
        </p>
        <Alert bsStyle="warning" className="published-local-version-warning">
            <p>
                {
                    stringReplace(
                        translations.LOCAL_RUNTIME_publish_to_local_runtime_version_warning,
                        { version: selectedRuntime.latestVersion || 'unknown' },
                    )
                }
            </p>
        </Alert>
    </React.Fragment>
);

export default ActivateSuccessRuntime;
